module.exports = __webpack_public_path__ + "img/DMA.eab191ee.svg";